export default __webpack_public_path__ + "static/media/string-of-pearls.03230ee4.svg";